// Trang "Xu & Hạng" (/xu-program): 4 tab — Cấu hình · Người tham gia · Thống kê · Nghi ngờ.
// Tab và người đang xem lưu trên URL (?tab=…&userId=…) để tải lại / gửi link vẫn đúng chỗ.
// Header đọc cờ + ngày ra mắt hạng; tab Cấu hình báo lại khi lưu để huy hiệu cập nhật ngay.
// Plan: plans/261013-1042-diem-danh-nhiem-vu-ranking/phase-07-admin.md
import { useCallback, useEffect, useState } from "react";
import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import xuProgramApi from "../../../api/xuProgramApi";
import XuConfigTab from "./xu-config-tab";
import XuParticipantsTab from "./xu-participants-tab";
import XuProgramHeader from "./xu-program-header";
import XuStatsTab from "./xu-stats-tab";
import XuSuspiciousTab from "./xu-suspicious-tab";

const TAB_KEYS = ["config", "users", "stats", "suspicious"];

export default function XuProgramSettingsPage() {
    const [params, setParams] = useSearchParams();
    const tab = TAB_KEYS.includes(params.get("tab")) ? params.get("tab") : "config";
    const userId = Number(params.get("userId")) || null;
    const [head, setHead] = useState({ flags: null, rankLaunchAt: null });

    useEffect(() => {
        xuProgramApi.getSettings()
            .then(({ data }) => setHead({ flags: data.data.flags, rankLaunchAt: data.data.config.rankLaunchAt }))
            .catch(() => {}); // huy hiệu chỉ là phụ; tab Cấu hình tự báo lỗi của nó
    }, []);

    const update = (next) => setParams(next, { replace: true });
    const openUser = (id) => update(id ? { tab: "users", userId: String(id) } : { tab: "users" });
    const onSettings = useCallback((patch) => setHead((h) => ({ ...h, ...patch })), []);

    const items = [
        { key: "config", label: "Cấu hình", children: <XuConfigTab onSettings={onSettings} /> },
        { key: "users", label: "Người tham gia", children: <XuParticipantsTab openUserId={userId} onOpenUser={openUser} /> },
        { key: "stats", label: "Thống kê", children: <XuStatsTab flags={head.flags} onOpenUser={openUser} /> },
        { key: "suspicious", label: "Nghi ngờ", children: <XuSuspiciousTab onOpenUser={openUser} /> },
    ];

    return (
        <div className="p-4 lg:p-5 space-y-3">
            <XuProgramHeader flags={head.flags} rankLaunchAt={head.rankLaunchAt} />
            <Tabs activeKey={tab} onChange={(k) => update({ tab: k })} items={items} destroyInactiveTabPane />
        </div>
    );
}
